"use client";

import { chakra, Container, Link, useMultiStyleConfig } from "@chakra-ui/react";
import React from "react";
import { NextLink } from "src/components/NextLink";
import { useTranslatedString } from "src/i18n/hooks";
import { Calculator } from "src/icons";
import { ProductPageProps } from "src/lib/cms/products";
import { getDataFromRecord } from "src/lib/cms/utils";
import { PremiumCalcButton } from "../PremiumCalcModal/PremiumCalcButton";
import { Product, Products } from "../Product/Product";
import { isStructuredText } from "../StructuredText/StructuredText";

export const ProductOrCategoryPageContent: React.FC<
	NonNullable<
		Extract<
			ProductPageProps,
			{ __typename: "ProductPageRecord" | "ProductCategoryRecord" }
		>
	>
> = (productOrCategory) => {
	const styles = useMultiStyleConfig("ProductOrCategoryPageContent");
	const t = useTranslatedString();

	const isProductPage = productOrCategory.__typename === "ProductPageRecord";
	const isCategoryPage =
		productOrCategory.__typename === "ProductCategoryRecord";
	const products = isCategoryPage
		? productOrCategory._allReferencingProductPages
		: [productOrCategory];

	if (isProductPage && !productOrCategory.showProduct) return null;

	return (
		<chakra.div sx={styles.wrapper}>
			<Container maxW="container.xl">
				<Products>
					{products.map((product) => {
						const { name, href } = getDataFromRecord(product);

						return (
							<Product
								key={product.id}
								description={
									isStructuredText(product.description)
										? product.description
										: undefined
								}
								startingPrice={
									product.currentVersion?.price ?? 0
								}
								priceDescription={
									product.currentVersion?.priceDescription ??
									null
								}
								title={name}
								icon={product.icon}
								headerAlignment="center"
							>
								<chakra.div marginTop="auto">
									<PremiumCalcButton
										productOrCategory={
											product.productCategory
												? product.productCategory.slug
												: product.slug
										}
										categoryProduct={
											product.productCategory
												? product.slug
												: undefined
										}
										id={`product_overview_premium_calc__${product.id}`}
										leftIcon={<Calculator />}
										mb={4}
										size="lg"
									/>

									{isCategoryPage && (
										<NextLink href={`/${href}`} passHref>
											<Link
												variant="outline"
												id={`product_overview_show_details__${product.id}`}
											>
												{t(
													"productGroupPageContent.detailsCta",
												)}
											</Link>
										</NextLink>
									)}
								</chakra.div>
							</Product>
						);
					})}
				</Products>
			</Container>
		</chakra.div>
	);
};

// 🔬 TBD: e2e
